import styled from 'styled-components';
import WidestInventorySvg from '../../../assets/onboarding/newHome/widest-inventory.svg';

const WidestInventoryIcon = styled(WidestInventorySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.4rem'};
height: ${props => props.height || '4.4rem'};
display: flex;
`;

export default WidestInventoryIcon;
